import React from 'react';
import {
  SliderLayout,
  LabelsContainer,
  SliderLabel,
  TicksAndTrackWrapper,
  TicksContainer,
  TickMark,
  SliderTrack,
  SliderHandle
} from './styles/Slider.styles';

const SliderControl = ({ control }) => {
  const orientation = control.factoryKey === 'control_vertical_slider' ? 'vertical' : 'horizontal';
  const range = control.maxValue - control.minValue;
  const numSteps = control.steps || 10;
  const ticks = Array.from({ length: numSteps + 1 }, (_, i) => (i / numSteps) * 100);
  const position = range > 0 ? ((control.value - control.minValue) / range) * 100 : 0;
  const firstLabelText = orientation === 'vertical' ? control.maxText : control.minText;
  const secondLabelText = orientation === 'vertical' ? control.minText : control.maxText;

  const Labels = () => (
    <LabelsContainer orientation={orientation}>
      <SliderLabel styleProps={control.attributes}>{firstLabelText}</SliderLabel>
      <SliderLabel styleProps={control.attributes}>{secondLabelText}</SliderLabel>
    </LabelsContainer>
  );

  const Ticks = () => (
    <TicksContainer orientation={orientation}>
      {ticks.map(tickPos => (
        <TickMark
          key={tickPos}
          positionPercent={tickPos}
          orientation={orientation}
          color={control.attributes.tickColor}
        />
      ))}
    </TicksContainer>
  );

  const Track = () => (
    <SliderTrack styleProps={control.attributes} orientation={orientation}>
      <SliderHandle positionPercent={position} orientation={orientation} />
    </SliderTrack>
  );

  if (orientation === 'vertical') {
    return (
      <SliderLayout orientation={orientation}>
        <Labels />
        <Ticks />
        <Track />
      </SliderLayout>
    );
  }

  // Horizontal
  return (
    <SliderLayout orientation={orientation}>
      <Labels />
      <TicksAndTrackWrapper orientation={orientation}>
        <Ticks />
        <Track />
      </TicksAndTrackWrapper>
    </SliderLayout>
  );
};

export default SliderControl;